var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuthenticationIcon = function SvgAuthenticationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9488_17411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.166 17.5H5.83268C4.91185 17.5 4.16602 16.7542 4.16602 15.8333V10C4.16602 9.07918 4.91185 8.33334 5.83268 8.33334H14.166C15.0868 8.33334 15.8327 9.07918 15.8327 10V15.8333C15.8327 16.7542 15.0868 17.5 14.166 17.5Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3323 5.83333C13.3323 3.9925 11.8398 2.5 9.99901 2.5C8.44068 2.5 7.14234 3.57417 6.77734 5.01917",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 8.33334V5.83334",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9488_17411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgAuthenticationIcon as ReactComponent };
export default __webpack_public_path__ + "authentication-icon.svg";